// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD4bueTtneHeau4FdaVc5En-ASQj14EKAU",
  authDomain: "icci-bf040.firebaseapp.com",
  projectId: "icci-bf040",
  storageBucket: "icci-bf040.firebasestorage.app",
  messagingSenderId: "898038397264",
  appId: "1:898038397264:web:1b96ec68b13ca397895455",
  measurementId: "G-1LYN965MZM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only if supported (avoids SSR errors)
export let analytics = null;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

// Firebase Authentication
export const auth = getAuth(app);

// Google login provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: "select_account" // Always show account chooser
});

// Apple login provider
export const appleProvider = new OAuthProvider("apple.com");
appleProvider.addScope("email");
appleProvider.addScope("name");
